import { render, staticRenderFns } from "./RailTimetableDetail.vue?vue&type=template&id=5825a14a&"
import script from "./RailTimetableDetail.vue?vue&type=script&lang=js&"
export * from "./RailTimetableDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5825a14a')) {
      api.createRecord('5825a14a', component.options)
    } else {
      api.reload('5825a14a', component.options)
    }
    module.hot.accept("./RailTimetableDetail.vue?vue&type=template&id=5825a14a&", function () {
      api.rerender('5825a14a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/RailTimetableDetail.vue"
export default component.exports